import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { Document } from '@contentful/rich-text-types'

export interface PartnerDetails {
  name: string | null
  code: string | null
  group: string | null
  description: string | null
  offerStartDate: string | null
  offerEndDate: string | null
  termsAndConditions: string | null
  confirmationMessage: string | null
  logo: {
    name: string | null
    caption: string | null
    imageUrl: string | null
    url: string | null
  }
  bannerImage: {
    name: string | null
    caption: string | null
    imageUrl: string | null
    url: string | null
  }
  isValid: boolean
  isActive: boolean
}

export type EmptyPartnerDetails = { code: string }

export interface InvalidPartnerDetails {
  code: string
  isActive?: boolean
  isValid?: boolean
}

const arePromoDatesValid = (partnerPromo: Queries.ContentfulPromoPartner): boolean => {
  let isValidStartDate = false
  let isValidEndDate = false

  isValidStartDate =
    !partnerPromo.offerStartDate ||
    new Date(partnerPromo.offerStartDate.replace(/ /g, 'T')).valueOf() <= Date.now()

  isValidEndDate =
    !partnerPromo.offerEndDate ||
    new Date(partnerPromo.offerEndDate.replace(/ /g, 'T')).valueOf() >= Date.now()


  return isValidStartDate && isValidEndDate
}

const mapRichTextToHtml = (richText: { raw: string | null } | null | undefined) => {
  if (!richText?.raw) return null;
  try {
    const parsedDocument = typeof richText.raw === 'string' ? JSON.parse(richText.raw) : richText.raw;
    return documentToHtmlString(parsedDocument as Document);
  } catch (error) {
    console.error('Error parsing rich text:', error);
    return null;
  }
}

const mapContentfulPartner = (
  promoPartner: Queries.ContentfulPromoPartner,
): PartnerDetails => {
  const mappedPartner = {
    ...promoPartner,
    description: mapRichTextToHtml(promoPartner.description),
    termsAndConditions: mapRichTextToHtml(promoPartner.termsAndConditions),
    confirmationMessage: mapRichTextToHtml(promoPartner.confirmationMessage),
    summary: mapRichTextToHtml(promoPartner.summary),
    logo: {
      name: promoPartner.logo?.title ?? null,
      caption: promoPartner.logo?.description ?? null,
      imageUrl: promoPartner.logo?.url ?? null,
      url: promoPartner.logoImageUrl
    },    
    bannerImage: {
      name: promoPartner.bannerImage?.title ?? null,
      caption: promoPartner.bannerImage?.description ?? null,
      imageUrl: promoPartner.bannerImage?.file?.url ?? null,
      url: promoPartner.bannerImageUrl
    },
    isValid: true,
    isActive: arePromoDatesValid(promoPartner),
  }
  return mappedPartner

}

export default async function fetcher(url: string): Promise<PartnerDetails> {
  const response = await fetch(url)
  const json = await response.json()
  if (!json.code) throw new Error('Not found')
  return mapContentfulPartner(json)
}
